module.exports = __webpack_public_path__ + "static/img/logo_pamcard_branco 1.4601900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/mainContent/logo_pamcard_branco 1.svg
// module id = 1831
// module chunks = 1